import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';

import type { LayoutProps } from './layout-types';

const styles = cssMap({
	rowStyle: {
		width: '100%',
	},
});

const REQUIRED_ELEMENTS_COUNT = 1;

export const TwoRowLayout = ({ elements, key }: LayoutProps) => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return (
		<Stack xcss={styles.rowStyle} space="space.100">
			<Box xcss={styles.rowStyle}>
				<DynamicLayoutComponent
					component={elements[0]}
					position="two-rows-bottom"
					key={`${key}-bottom`}
				/>
			</Box>
			<Box xcss={styles.rowStyle}>
				<DynamicLayoutComponent
					component={elements[1]}
					position="two-rows-bottom"
					key={`${key}-bottom`}
				/>
			</Box>
		</Stack>
	);
};
